import { UpsellItem } from '@guest-widgets/shared/src/types/product/upsellItem';
import { CartItem } from '@guest-widgets/shared/src/types/product/cartItem';

export type ProductProp = CartItem | UpsellItem;

/**
 * Type guard to check if an item is an UpsellItem
 * @param item The item to check
 * @returns true if the item is an UpsellItem
 */
export const isUpsellItem = (item: ProductProp): item is UpsellItem => {
  return (item as UpsellItem).parent !== undefined;
};
